import * as React from "react";
import "./App.css";
import { useMoralis } from "react-moralis";

const banner = require("./img/banner.png");
const thumbnail = require("./img/thumbnail.png");
const Moralis = require("moralis");
//settings
const price = 5e15; // 0.005 ETH
const etherscanDomain = "https://etherscan.io/tx/";
const contractAddress = "0x85371D83181F584506cD52A693E0Ced9984D27aD";

const App = () => {
  const {
    authenticate,
    isAuthenticated,
    isAuthenticating,
    logout,
  } = useMoralis();

  const [quantity, setQuantity] = React.useState(0);
  const [errorTransaction, setErrorTransaction] = React.useState("");
  const [sessionExpired, setSessionIsExpired] = React.useState(false);
  const [success, setsuccess] = React.useState("");
  const [isLoading, setIsLoading] = React.useState(false);

  const onChange = (e: any) => {
    setQuantity(e.currentTarget.value);
  };

  const login = async () => {
    if (!isAuthenticated || sessionExpired) {
      await authenticate({ signingMessage: "" })
        .then(function() {
          setSessionIsExpired(false);
          setErrorTransaction("");
          setsuccess("");
          setIsLoading(false);
        })
        .catch(function() {
          setSessionIsExpired(true);
        });
    }
  };

  const logOut = async () => {
    setSessionIsExpired(true);
    await logout();
  };

  const onClick = (e: React.FormEvent) => {
    e.preventDefault();

    transaction();
  };

  async function transaction() {
    const sendOptions = {
      contractAddress: contractAddress,
      functionName: "mint",
      abi: [
        {
          inputs: [
            { internalType: "uint256", name: "quantity", type: "uint256" },
          ],
          name: "mint",
          outputs: [],
          stateMutability: "payable",
          type: "function",
        },
      ],
      params: {
        quantity: quantity,
      },
      msgValue: price * quantity,
    };
    try {
      const transaction = await Moralis.executeFunction(sendOptions);
      setIsLoading(true);

      // Wait until the transaction is confirmed
      await transaction.wait();

      setsuccess(`${etherscanDomain}${transaction.hash}`);
    } catch (error) {
      let errorMessage = "Failed to do something exceptional";
      if (error instanceof Error) {
        const errMsg = error.message;
        if (errMsg.includes("authenticate")) {
          setSessionIsExpired(true);
        } else if (errMsg.includes("Insufficient funds sent")) {
          setErrorTransaction(
            "Insufficient funds sent. Check the balance in your wallet and try again."
          );
        } else if (errMsg.includes("Cannot mint that many at once")) {
          setErrorTransaction(
            "Cannot mint that many at once Please try again with a smaller amount."
          );
        } else if (errMsg.includes("Quantity cannot be zero")) {
          setErrorTransaction(
            "Amount cannot be zero. Please try again with a higher amount."
          );
        } else if (
          errMsg.includes("The limit of minting per address is exceeded")
        ) {
          setErrorTransaction(
            `The limit of minting per address is exceeded. Thank you for your serivce!`
          );
        } else if (errMsg.includes("Not enough NFTs left to mint")) {
          setErrorTransaction(
            "Not enough NFTs left to mint. Better luck next time!"
          );
        }
      }
      console.log(errorMessage);
    }
  }

  return (
    <div className="App">
      <div className="d-flex h-100 text-center text-white ">
        <div className="cover-container d-flex w-100 h-100 mx-auto flex-column">
          <div>
            <img src={banner} className="banner" alt="banner"></img>
            <div id="content" className="px-3">
              {!isAuthenticated || sessionExpired ? (
                <div>
                  <button
                    id="btn-connect-wallet"
                    className="btn btn-lg btn-secondary fw-bold border-white bg-white"
                    onClick={login}
                  >
                    <h1> Connect to MetaMask</h1>
                  </button>
                </div>
              ) : (
                <div>
                  <div id="purchase" className="p.solid">
                    <div className="card flex-md-row mb-4 p-4 box-shadow h-md-250">
                      <div className="card-body d-flex flex-column align-items-start">
                        <h3 className="mb-0">
                          <p className="text-dark">Turbo Cats.</p>
                        </h3>
                        <div className="mb-1 text-muted">0.005 ETH</div>
                        <p className="card-text mb-auto text-dark">
                          Max 5 mints per TX
                        </p>
                        <p className="card-text mb-auto text-dark">
                          Max 20 per wallet
                        </p>
                        <div>
                          <label className="text-dark m-2">Quantity</label>
                          <input
                            className="input-amount m-2"
                            type="number"
                            id="amount"
                            name="amount"
                            min={1}
                            onChange={(e) => onChange(e)}
                          />
                          <button
                            id="btn-amount"
                            className="btn btn-success btn-success btn-lg fw-bold m-2"
                            onClick={onClick}
                          >
                            Mint
                          </button>
                        </div>
                        <div>
                          {success.length > 0 ? (
                            <div>
                              <p className="text-success">Success!</p>

                              <a
                                href={` ${success}`}
                                target="_blank"
                                rel="noreferrer"
                              >
                                Etherscan
                              </a>
                            </div>
                          ) : isLoading ? (
                            <p className="text-primary">
                              Loading transaction.....
                            </p>
                          ) : (
                            ""
                          )}
                        </div>
                        <div>
                          {errorTransaction && isAuthenticated && (
                            <p className="text-danger"> {errorTransaction}</p>
                          )}
                        </div>
                      </div>
                      <img
                        className="card-img-right flex-auto d-none d-md-block"
                        alt="Thumbnail [250x250]"
                        width={250}
                        height={250}
                        src={thumbnail}
                        data-holder-rendered="true"
                      ></img>
                    </div>
                  </div>
                  <button
                    id="btn-logout"
                    className="btn btn-lg btn-secondary fw-bold border-white bg-white"
                    onClick={logOut}
                    disabled={isAuthenticating}
                  >
                    Log out from MetaMask
                  </button>
                </div>
              )}
              <div>
                {sessionExpired && isAuthenticated && (
                  <p className="text-danger m-4">
                    Your session was expired, please try to connect with
                    MetaMask again.
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default App;
